export enum GzSelectMenuWithButtonEvents {
  CLICK = 'click',
  CHANGE = 'change',
}
